import { getTestId } from '@airtel/air-design-system';
var data = [{
  packTitle: {
    text: '56 days validity'
  },
  packSubTitle: 'here is the text that will be used as the subtitle',
  iconName: 'CalendarButtonIcon',
  hideRightChevronIcon: true
}, {
  packTitle: {
    multiText: [{
      text: '56 days validity '
    }, {
      text: '1.5 GB',
      isStriked: true
    }]
  },
  strikedText: '1.5 GB',
  iconName: 'MobileDataIcon',
  infoTagText: '500 MB extra',
  hideRightChevronIcon: true
}, {
  packTitle: {
    text: 'unlimited local & STD calls'
  },
  iconName: 'CallIcon',
  hideRightChevronIcon: true
}];
export var defaultProps = Object.assign({
  data,
  title: 'the title of the plan',
  subTitle: 'here is the text that will be used as the subtitle',
  ctaText: 'button'
}, getTestId('PackDetailsWidgetContainer'));